import CryptoJS from 'crypto-js'

// DES加密
const key = CryptoJS.enc.Utf8.parse('Qi9kGRgDxEEcX5Jifntv32==')
const iv = CryptoJS.enc.Utf8.parse('15843799')
const encryptBy = (message) => {
  var encrypted = CryptoJS.DES.encrypt(message, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}

// DES解密
const decryptBy = (ciphertext) => {
  const decrypted = CryptoJS.DES.decrypt({
    ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
  }, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
}

// md5 加密
const encryptByMD5 = (data) => {
  return CryptoJS.MD5(data).toString()
}

export default {
  encryptBy,
  decryptBy,
  encryptByMD5
}